import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'district-ui-client/transforms/string'

export default class ImportSchedule extends Model {
  @attr<StringTransform>('string') declare status: string

  get isComplete() {
    return this.status === 'complete'
  }

  get hasFailed() {
    return this.status === 'failed'
  }

  get isScheduled() {
    return this.status === 'scheduled'
  }

  get isBusy() {
    return this.status === 'busy'
  }

  get shouldRetry() {
    return this.status === 'retry'
  }

  get isStillRunning() {
    return this.isScheduled || this.isBusy || this.shouldRetry
  }

  [Type] = 'import-schedule' as const
}
